import React from 'react'
import { Stack, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import RadioGroup from 'components/generic/form/RadioGroup'

const FormattedRadioGroup = ({ control, name, title, items, ...restProps }) => (
  <Stack flexGrow={1} px={4}>
    <Grid container mt={1}>
      <Grid item md={12} xs={12}>
        <Typography variant="h6">{title}</Typography>
        <RadioGroup
          row
          defaultValue=""
          control={control}
          name={name}
          label=""
          items={items}
          radioGroupProps={{ sx: { pl: 1, pt: 3 } }}
          {...restProps}
        />
      </Grid>
    </Grid>
  </Stack>
)

FormattedRadioGroup.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
}

FormattedRadioGroup.defaultProps = {
  control: {},
  name: '',
  title: '',
  items: [],
}

export default FormattedRadioGroup
